import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { getAppointedPersonsLV } from '../../../services/plantSafetyWorkPermitService';
import { notifyAOCRevoke } from '../../../services/lvWorkPermitFlowService';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  permitId: number;
  onSuccess?: () => void;
}

const NotifyAOCRevokeModal: React.FC<Props> = ({ isOpen, onClose, permitId, onSuccess }) => {
  const [appointedPersons, setAppointedPersons] = useState<any[]>([]);
  const [selectedPerson, setSelectedPerson] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      loadAppointedPersons();
    }
  }, [isOpen]);

  const loadAppointedPersons = async () => {
    try {
      const response = await getAppointedPersonsLV();
      setAppointedPersons(response?.data || response || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    if (!selectedPerson) {
      alert('Please select an appointed person');
      return;
    }

    try {
      setLoading(true);

      await notifyAOCRevoke(permitId, {
        user_ids: [Number(selectedPerson)],
      });

      onSuccess?.();
      onClose();
    } catch (error) {
      console.error('Error notifying revoke:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white w-[480px] rounded-xl shadow-xl p-6 relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-gray-800">
          <X size={20} />
        </button>

        <h2 className="text-lg font-semibold mb-5">Notify to Revoke Suspension</h2>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select Appointed Person</label>

          <select
            value={selectedPerson}
            onChange={(e) => setSelectedPerson(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2"
          >
            <option value="">Select Appointed Person</option>

            {appointedPersons.map((person) => (
              <option key={person.id} value={person.id}>
                {person.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-6 py-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={!selectedPerson || loading}
            className={`px-6 py-2 rounded-md text-white ${
              selectedPerson && !loading ? 'bg-red-500 hover:bg-red-600' : 'bg-red-300 cursor-not-allowed'
            }`}
          >
            {loading ? 'Sending...' : 'Done'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotifyAOCRevokeModal;
